// src/pages/Privacy/PrivacyPage.js
import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useLanguage } from '../../contexts/LanguageContext';
import './PrivacyPage.css';

const PrivacyPage = () => {
  const [markdownContent, setMarkdownContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { language } = useLanguage();
  
  // Determine which markdown file to load based on language
  const markdownFile = language === 'en' ? '/markdown/privacy-en.md' : '/markdown/privacy.md';

  useEffect(() => {
    const fetchMarkdown = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(markdownFile);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch privacy policy: ${response.status}`);
        }
        
        const text = await response.text();
        setMarkdownContent(text);
      } catch (err) {
        console.error('Error fetching privacy markdown:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMarkdown();
  }, [markdownFile, language]);

  if (isLoading) {
    return (
      <div className="privacy-container">
        <div className="privacy-loading">
          <div className="loading-spinner"></div>
          <p>Loading privacy policy...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="privacy-container">
        <div className="privacy-error">
          <h2>Error loading privacy policy</h2>
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>Try Again</button>
        </div>
      </div>
    );
  }

  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <ReactMarkdown>{markdownContent}</ReactMarkdown>
      </div>
    </div>
  );
};

export default PrivacyPage;